<template>
  <div class="flex flex-col">
    <InputLabel :labelClass="label_class" :forId="id" :label="label"/>
    <textarea class="px-3 py-2 rounded-2xl border bg-transparent border-white/50 text-sm text-white focus:outline-none focus:shadow-lg focus:shadow-white/70 transition-shadow duration-500"
      :rows="rows"
      :id="id"
      :class="textarea_class"
      :value="modelValue"
      :disabled="is_disabled"
      @input="$emit('update:modelValue', $event.target.value)"
    ></textarea>
  </div>
</template>

<script>
import InputLabel from './InputLabel.vue'; // Import the new Label component

export default {
  name: 'TextArea',
  components: {
    InputLabel
  },
  emits: ['update:modelValue'],
  props: {
    label: String,
    label_class: String,
    id: String,
    name: String,
    class: String,
    modelValue: String,
    textarea_class: String,
    rows: String,
    is_disabled: Boolean
  },
}
</script>
